import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
import VueGtag from 'vue-gtag'
import App from './App.vue'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false
Vue.config.ignoredElements = [
  'tmo-digital-header',
  'tmo-digital-footer'
]

Vue.use(VueTheMask)
Vue.use(VueGtag, {
  config: { id: '366827885' }
})

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
